import { SVGProps } from "react";

interface EmailIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export default function EmailIcon({
  size,
  className = "",
  ...props
}: EmailIconProps) {
  return (
    <svg
      width={size || 19}
      height={size ? (size * 15) / 19 : 15}
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M0 15V0H19V15H0ZM9.5 8.05775L1.5 2.94225V13.5H17.5V2.94225L9.5 8.05775ZM9.5 6.5L17.3463 1.5H1.65375L9.5 6.5ZM1.5 2.94225V1.5V13.5V2.94225Z"
        fill="currentColor"
      />
    </svg>
  );
}
